import * as analytic from '@anm/analytic';
import Dropdown from '@anm/components/Dropdown';
import Tooltip from '@anm/components/Tooltip';
import isMobile from '@anm/helpers/is/isMobile';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import DropdownContent from './DropdownContent';
import { Button, Row, Text, Wrapper } from './Wrapper';
import { AddDestinationButtonProps, SimpleButtonProps } from './types';

export { Wrapper };

export const SimpleButton: FC<SimpleButtonProps> = ({ buttonText, onClick, children, renderTooltip }) => (
  <Row {...{ onClick }}>
    <Tooltip withArrow variant="black" direction="to-top" renderContent={renderTooltip}>
      {children || <Button />}
    </Tooltip>
    {buttonText && <Text>{buttonText}</Text>}
  </Row>
);

const AddDestinationButton: FC<AddDestinationButtonProps> = ({
  list,
  isError,
  children,
  buttonText,
  renderTooltip,
  onAddRtmp = noop,
  onSelectDestination,
  direction = 'to-bottom',
  ...dropdownProps
}) => (
  <Wrapper isFullWidthDropdown={!!children}>
    <Dropdown
      openByAction="click"
      direction={isMobile() ? 'to-top' : 'to-bottom'}
      openerVariant="default"
      autoClose={true}
      renderContent={({ isOpenContent }) =>
        isOpenContent ? <DropdownContent {...{ list, onAddRtmp, onSelectDestination }} /> : null
      }
      {...dropdownProps}
    >
      <SimpleButton
        {...{ children, buttonText, renderTooltip }}
        onClick={() => analytic.trackMyStreamsAddNewDestinationClick()}
      />
    </Dropdown>
  </Wrapper>
);

export default AddDestinationButton;
